///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.users = abcsetup.users || {};
abcsetup.users.common = abcsetup.users.common || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.users.common = {
    init: function() {
        $('#email').on('change', function() {
            abcsetup.set_case.users.common._checkExistingNonUsers($(this).val());
        });
    },
}
